import { render, staticRenderFns } from "./PageCatalogConfigurable.vue?vue&type=template&id=7c63d943&"
import script from "./PageCatalogConfigurable.js?vue&type=script&lang=js&"
export * from "./PageCatalogConfigurable.js?vue&type=script&lang=js&"
import style0 from "./PageCatalogConfigurable.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PageCatalogConfigurable.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Foknadverenamiru%2Fcomponents%2Fproduct%2FPageCatalogConfigurable%2FPageCatalogConfigurable.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports